import { Engagement } from 'src/editor/insights/constants';

export const DashboardInsightsTabTypes = ['content', 'journeys', 'visitors', 'synced-steps'] as const;
export type DashboardInsightsTabType = typeof DashboardInsightsTabTypes[number];

export type BreadcrumbsConfig = {
  items: {
    value: string;
    onClick?: () => any;
  }[];
};

export type MetricCard = {
  value: number | string | JSX.Element;
  delta?: number;
  title: string;
  key: string;
  tooltip?: string;
};

export type MetricCardsConfig = {
  key: string;
  filter: (e: Engagement) => boolean;
  title: string;
  valueCreator: (value: number) => string;
  tooltipContentCreator: (value: number) => string;
}[];

export type TimePeriodParam = {
  start_time?: string;
  end_time?: string;
};

export type TimePeriodKey = 'last_30_days' | 'all_time';
export type TimePeriodOption = {
  key: TimePeriodKey;
  label: string;
  param: TimePeriodParam;
};

export type JourneyMetrics = {
  journey_id: number;
  num_of_steps: number;
  average_time: number;
  num_sessions: number;
  average_completion_percentage: number;
};


export type JourneyHomeMetrics = {
  num_of_steps: number;
  average_time?: number;
  num_sessions?: number;
  average_completion_percentage: number;
};
